import { Divider, Grid, Typography } from "@mui/material";
import { ActionButton } from "../../../../components/Button";
import Dialog from "../../../../components/Dialog";
import { IRemoveDialogProps } from "../../../../components/Dialog";
import { useLanguageContext } from "../../../../contexts/LanguageContext";
import IEnterprise from "../../../../interfaces/IEnterprise";
import DefaultConstants from "../../../../data/Constants";
import FormHelper from "../../../../helpers/FormHelper";
import EnterpriseService from '../../../../services/EnterpriseService';
import { RegistrationStatusData } from "../../../../data/Enums";
import { useCallback, useMemo } from 'react';
import DateTimeHelper from "../../../../helpers/DateTimeHelper";


const RemoveDialog: React.FunctionComponent<IRemoveDialogProps<IEnterprise>> = ({
    open,
    handleClose,
    data,
    handleListRefresh = () => {}
}) => {
    const { translate } = useLanguageContext();


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let formData = FormHelper.Create(event);
        formData = FormHelper.Add(formData, 'id', data?.id);

        EnterpriseService.Remove(formData).then(() => {
            handleClose();
            handleListRefresh();
        });

        // eslint-disable-next-line
    }, [data]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action="no" onClick={handleClose} />, 
            <ActionButton action="yes" type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);
    

    const expiresAtDiff = useMemo(() => {
        return DateTimeHelper.Diff(data?.expiresAt ?? '', DateTimeHelper.Now());
    }, [data]);


    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('remove')}
            dialogActions={dialogActions}
            fullWidth={true}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween'
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <Typography variant='body1'>
                        {translate('_removeDialogDescription')}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                        <Grid item xs={12}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('name')}
                            </Typography>

                            <Typography variant='body2'>
                                {data?.name ?? '-'}
                            </Typography>
                        </Grid>

                        <Grid item md={6} xs={12}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate(expiresAtDiff < 0 ? 'expiredAt' : 'expiresAt')}
                            </Typography>

                            <Typography variant='body2' className={`${expiresAtDiff < 0 ? 'color-red' : expiresAtDiff < 5 ? 'color-amber' : ''}`}>
                                {DateTimeHelper.Format(`${data?.expiresAt}T23:59:59`)}
                            </Typography>
                        </Grid>

                        <Grid item md={6} xs={12}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('situation')}
                            </Typography>

                            <Typography variant='body2'>
                                {translate(RegistrationStatusData[data?.registrationStatusId ?? 0].name)}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('token')}
                            </Typography>

                            <Typography variant='body2'>
                                {data?.token ?? '-'}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default RemoveDialog;